import { Skeleton } from '../../Skeleton'

import { ACTIONS_COUNT } from './ProfileActionsWidgetSkeleton.constants'

import * as styles from './ProfileActionsWidgetSkeleton.module.css'

function ProfileActionsWidgetSkeleton({
  actionsCount = ACTIONS_COUNT,
  className = styles.ProfileActionsWidgetSkeleton,
}) {
  return (
    <div className={className}>
      {Array.from({ length: actionsCount }).map((_, index) => (
        <Skeleton className={styles.action} key={index} />
      ))}
    </div>
  )
}

export default ProfileActionsWidgetSkeleton
